import { NavLink } from 'react-router-dom';
import CustomerHead from '../../components/customer/CustomerHead';

import styled from 'styled-components';

export default function NotificationDetail(){
  return (
    <ComplaintWrap>
      <CustomerHead title="Complaint" desc="Voice of Dissatisfaction" />
      <main className="content">
        <div className="card">
          {/* 공지 제목 */}
          <strong>Notification Title</strong>

          <div className="noti-wrap">
            <div className="noti-content">
              {/* 공지 내용 */}
              <p>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
              </p>
            </div>
            <div className="noti-btn">
              <NavLink to="/customer/notice">List</NavLink>
            </div>
          </div>
        </div>
      </main>
    </ComplaintWrap>
  )
}

const ComplaintWrap = styled.div`
  position: relative;
  background: #F9FAFB;

  .content {
    position:relative;
    padding: 20px;
    height:calc(100vh - 132px);
    overflow-y:auto;

    .card {
      background: #fff;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      height: 100%;
      
      strong {
        display: block;
        font-size: 18px;
        font-weight: 700;
        color: #111827;
      }
      
      .noti-wrap {
        margin-top: 15px;
        
        .noti-content {
          position:relative;
          
          p {
            font-size:16px;
            font-weight:500;
            line-height:1.4;
            color:#111;
          }
        }
        
        .noti-btn {
          margin-top:30px;
          position:relative;
          display:flex;
          justify-content: flex-end;
          align-items: center;
          
          a {
            display:block;
            padding:0 50px;
            height:30px;
            line-height:30px;
            font-weight:500;
            font-size:14px;
            color:#fff;
            background:#0072B9;
            text-align:center;
            border-radius:5px;
          }
        }
      }
    }
  }
`